export const ID = 'APP_GLOBAL';
export const SHOW_DTI = `${ID}/SHOW_DTI`;
export const SHOW_DTI_FAILED = `${ID}/SHOW_DTI_FAILED`;
